<template>
  <div>
    <b-alert
      :show="!hasPickupCourier"
      variant="danger"
      closable
    >
      Layanan Pickup hanya tersedia pada JNE atau J&T. Harap aktifkan melalui halaman pengaturan kurir di tab sebelumnya.
    </b-alert>
    <validation-observer ref="simpleRules">
      <b-form>
        <!-- Cabang JNE -->
        <b-form-group
          label="Cabang JNE*"
        >
          <validation-provider
            #default="{ errors }"
            name="Cabang JNE"
            rules="required"
          >
            <v-select
              v-model="form.pickup_jne_branch"
              :options="branches"
              label="text"
              :state="errors.length > 0 ? false : null"
              :disabled="!hasPickupCourier"
              :reduce="option => option.value"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Cabang JNE -->
        <b-form-group
          label="Waktu pickup*"
        >
          <validation-provider
            #default="{ errors }"
            name="Waktu pickup"
            rules="required"
          >
            <b-form-timepicker
              v-model="form.pickup_time"
              locale="id"
            />
            <div>
              <small class="text-danger">{{ errors[0] }}</small>
            </div>
          </validation-provider>
        </b-form-group>

        <!-- Preferensi Kendaraan -->
        <b-form-group
          label="Preferensi Kendaraan*"
        >
          <validation-provider
            #default="{ errors }"
            name="Preferensi Kendaraan"
            rules="required"
          >
            <div class="demo-inline-spacing">
              <b-form-radio
                v-model="form.pickup_vehicle"
                class="mt-0"
                name="type"
                value="MOTOR"
                :disabled="!hasPickupCourier"
              >
                Motor
              </b-form-radio>
              <b-form-radio
                v-model="form.pickup_vehicle"
                class="mt-0"
                name="type"
                value="MOBIL"
                :disabled="!hasPickupCourier"
              >
                Mobil
              </b-form-radio>
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <h3 class="mt-3 mb-1">
          PIC Pickup
        </h3>

        <!-- Nama PIC -->
        <b-form-group
          label="Nama PIC*"
        >
          <validation-provider
            #default="{ errors }"
            name="Nama PIC"
            rules="required"
          >
            <b-form-input
              v-model="form.pickup_pic_name"
              :state="errors.length > 0 ? false : null"
              :disabled="!hasPickupCourier"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Telepon PIC -->
        <b-form-group
          label="Telepon PIC*"
        >
          <validation-provider
            #default="{ errors }"
            name="Telepon PIC"
            rules="required"
          >
            <b-form-input
              v-model="form.pickup_pic_phone"
              placeholder="+628XXXXXXXXX"
              :state="errors.length > 0 ? false : null"
              :disabled="!hasPickupCourier"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <h3 class="mt-3 mb-1">
          Lokasi Pickup
        </h3>

        <b-alert
          variant="warning"
          show
          class="d-flex"
        >
          <feather-icon
            class="mr-25"
            size="20"
            icon="InfoIcon"
          />
          <div class="ml-25">
            Saat ini hanya mendukung satu lokasi pickup. Mohon pastikan semua produk berada lokasi tersebut.
          </div>
        </b-alert>

        <!-- Latitude -->
        <b-form-group
          label="Latitude"
        >
          <validation-provider
            #default="{ errors }"
            name="Latitude"
            rules=""
          >
            <b-form-input
              v-model="form.pickup_latitude"
              placeholder="Opsional"
              :state="errors.length > 0 ? false : null"
              :disabled="!hasPickupCourier"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Longitude -->
        <b-form-group
          label="Longitude"
        >
          <validation-provider
            #default="{ errors }"
            name="Longitude"
            rules=""
          >
            <b-form-input
              v-model="form.pickup_longitude"
              placeholder="Opsional"
              :state="errors.length > 0 ? false : null"
              :disabled="!hasPickupCourier"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  BFormGroup,
  BFormTimepicker,
  BAlert,
  BForm,
  BFormInput,
  BFormRadio,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'BrandFormAddress',
  components: {
    vSelect,
    BFormTimepicker,
    BAlert,
    BFormGroup,
    BForm,
    BFormInput,
    BFormRadio,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      branches: [
        { value: 'CGK001', text: 'JNE HEAD OFFICE' },
        { value: 'CGK000', text: 'JNE JAKARTA' },
        { value: 'BDO000', text: 'JNE BANDUNG' },
        { value: 'CBN000', text: 'JNE CIREBON' },
        { value: 'BKI000', text: 'JNE BEKASI' },
        { value: 'SUB000', text: 'JNE SURABAYA' },
        { value: 'MGL000', text: 'JNE MAGELANG' },
        { value: 'TJQ000', text: 'JNE TANJUNG PANDAN' },
        { value: 'TNJ000', text: 'JNE TANJUNG PINANG' },
        { value: 'UPG000', text: 'JNE MAKASSAR' },
        { value: 'BTJ000', text: 'JNE BANDA ACEH' },
        { value: 'TSM000', text: 'JNE TASIKMALAYA' },
        { value: 'BTH000', text: 'JNE BATAM' },
        { value: 'SMD000', text: 'JNE SAMARINDA' },
        { value: 'BDJ000', text: 'JNE BANJARMASIN' },
        { value: 'TKG000', text: 'JNE BANDAR LAMPUNG' },
        { value: 'BPN000', text: 'JNE BALIKPAPAN' },
        { value: 'CXP000', text: 'JNE CILACAP' },
        { value: 'DJJ000', text: 'JNE JAYAPURA' },
        { value: 'KDI000', text: 'JNE KENDARI' },
        { value: 'PKY000', text: 'JNE PALANGKARAYA' },
        { value: 'PGK000', text: 'JNE PANGKAL PINANG' },
        { value: 'MDC000', text: 'JNE MANADO' },
        { value: 'TGR000', text: 'JNE TANGERANG' },
        { value: 'TRK000', text: 'JNE TARAKAN' },
        { value: 'AMI000', text: 'JNE MATARAM' },
        { value: 'AMQ000', text: 'JNE AMBON' },
        { value: 'BKS000', text: 'JNE BENGKULU' },
        { value: 'BOO000', text: 'JNE BOGOR' },
        { value: 'BTG000', text: 'JNE BONTANG' },
        { value: 'CLG000', text: 'JNE CILEGON' },
        { value: 'DJB000', text: 'JNE JAMBI' },
        { value: 'DPS000', text: 'JNE DENPASAR' },
        { value: 'GTO000', text: 'JNE GORONTALO' },
        { value: 'JBR000', text: 'JNE JEMBER' },
        { value: 'JOG000', text: 'JNE YOGYAKARTA' },
        { value: 'KDR000', text: 'JNE KEDIRI' },
        { value: 'KOE000', text: 'JNE KUPANG' },
        { value: 'MDN000', text: 'JNE MADIUN' },
        { value: 'PDG000', text: 'JNE PADANG' },
        { value: 'PLM000', text: 'JNE PALEMBANG' },
        { value: 'PLW000', text: 'JNE PALU' },
        { value: 'PKU000', text: 'JNE PEKANBARU' },
        { value: 'PNK000', text: 'JNE PONTIANAK' },
        { value: 'MES000', text: 'JNE MEDAN' },
        { value: 'MXG000', text: 'JNE MALANG' },
        { value: 'PBL000', text: 'JNE PROBOLINGGO' },
        { value: 'SRG000', text: 'JNE SEMARANG' },
        { value: 'SOC000', text: 'JNE SOLO' },
        { value: 'SMI000', text: 'JNE SUKABUMI' },
        { value: 'MJK000', text: 'JNE MOJOKERTO' },
        { value: 'TTE000', text: 'JNE TERNATE' },
        { value: 'DPK000', text: 'JNE DEPOK' },
        { value: 'SOQ000', text: 'JNE SORONG' },
        { value: 'LBJ000', text: 'JNE LABUAN BAJO' },
        { value: 'KRW000', text: 'JNE KARAWANG' },
        { value: 'SIN000', text: 'JNE SINGAPURA' },
        { value: 'LHR000', text: 'JNE LHR' },
        { value: 'HKG000', text: 'JNE HONGKONG' },
        { value: 'TIM000', text: 'JNE TIMIKA' },
        { value: 'SEL000', text: 'JNE KOREA' },
        { value: 'USA000', text: 'JNE USA' },
        { value: 'MNL000', text: 'JNE PHILIPINES' },
        { value: 'BKK000', text: 'JNE THAILAND' },
        { value: 'NBX000', text: 'JNE NABIRE' },
        { value: 'PSR000', text: 'JNE PASURUAN' },
        { value: 'PWT000', text: 'JNE PURWAKARTA' },
        { value: 'SDA000', text: 'JNE SIDOARJO' },
        { value: 'TGL000', text: 'JNE TEGAL' },
        { value: 'DTB000', text: 'JNE SILANGIT' },
        { value: 'MKQ000', text: 'JNE MERAUKE' },
        { value: 'CKR000', text: 'JNE CIKARANG' },
        { value: 'UPX000', text: 'MAKASSAR GATEWAY' },
        { value: 'SUX000', text: 'SURABAYA GATEWAY' },
        { value: 'CGX000', text: 'JAKARTA GATEWAY' },
        { value: 'BUX000', text: 'BANDUNG GATEWAY' },
        { value: 'WGX000', text: 'WANGON GATEWAY' },
      ],
    }
  },
  computed: {
    ...mapState('brand', ['selectedCouriers']),
    hasPickupCourier() {
      return this.selectedCouriers.find(item => item.code === 'jne' || item.code === 'jnt') !== undefined
    },
  },
  methods: {
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()
      return response
    },
  },
}
</script>
